import { render, staticRenderFns } from "./ViewQcResultModal.vue?vue&type=template&id=f2dfbb04&scoped=true&"
import script from "./ViewQcResultModal.vue?vue&type=script&lang=js&"
export * from "./ViewQcResultModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewQcResultModal.vue?vue&type=style&index=0&id=f2dfbb04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2dfbb04",
  null
  
)

export default component.exports